import styled,{ css } from 'styled-components';

export const ToolBarDiv = styled.div<{
  compliance:boolean
}>`
position: fixed;
top: 0;
width: 100%;
height: 64px;
box-sizing:border-box;
padding:5%;
background-color: #ffff;
display:flex;
flex-direction:row;
align-items:center;
justify-content:space-between;
z-index: 100;
${(props)=>
  props.compliance  &&
  css`
  padding:0%;
  height:75px;`
}
`;

export const HamburgerImg = styled.img`
  src:${props=>props.src};
  width:${props=>props.width};
  height:${props=>props.height};
`;

export const BizName = styled.span`
width:90%;
font-family: Nunito,sans-Serif;
font-style: normal;
font-weight: bold;
font-size: 18px;
line-height: 140%;
display: flex;
align-items: center;
margin-left:5%;
color: #1E1E1E;
`;

export const ToolBarIconsDiv = styled.div`
position:static;
display:flex;
width:86px;
flex-direction:row;
justify-content:space-between;
align-items:center;
`;

export const INVBizName = styled(BizName)`
margin-left:0%;
`;

export const BizDetails = styled(INVBizName)`
font-family: Nunito;
font-style: normal;
font-weight: normal;
font-size: 12px;
line-height: 140%;
color: #6D6D6D;
`;

export const RefreshLink = styled('div')`
display: flex;
font-family: 'nunito', sans-serif;
font-style: normal;
font-weight: 600;
font-size: 14px;
line-height: 22px;
text-align: center;
letter-spacing: 0.01em;
align-self: stretch;
text-decoration: none;
color: rgb(30, 30, 30);
cursor: pointer;
`